import { __assign, __rest } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './Loader.scss';
export var LoaderSizes = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
    XSMALL: 'xsmall'
};
var Loader = function (_a) {
    var className = _a.className, isDarkMode = _a.isDarkMode, size = _a.size, props = __rest(_a, ["className", "isDarkMode", "size"]);
    var containerClass = classnames('Loader', "Loader--".concat(size), className, {
        'Loader--isDarkMode': isDarkMode
    });
    return React.createElement("div", __assign({}, props, { "aria-label": 'Loading...', className: containerClass }));
};
Loader.defaultProps = {
    isDarkMode: false,
    size: LoaderSizes.MEDIUM
};
Loader.propTypes = {
    className: PropTypes.string,
    isDarkMode: PropTypes.bool,
    size: PropTypes.oneOf(Object.values(LoaderSizes))
};
export default Loader;
//# sourceMappingURL=Loader.js.map